<template>
  <el-dialog class="dialog_class" title="" :visible.sync="centerDialogVisible" width="50%" style="margin-top: -10vh">
    <dialog-item v-if="centerDialogVisible" v-model="meta" :path="type" :isHeight="H" :initCheckboxVal="initCheckboxVal" :isDialog="true" class="dialog-report"></dialog-item>
    <span slot="footer" class="dialog-footer">
      <el-button @click="centerDialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="sure">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import dialogItem from '@/views/config/index.vue'
export default {
  data() {
    return {
      centerDialogVisible: false,
      type: '',
      H: '600',
      selectedVal: '', // 单选
      checkboxVal: [], // 复选
      meta: {}, // 弹层回显值
      formData: {},
      orderUser: '',
      initCheckboxVal: []
    }
  },
  watch: {
    meta(val) {
      const formData = this.formData
      if (formData && val && val.params.length > 0) {
        val.params.forEach((item) => {
          if (formData[item.name]) {
            item.value = formData[item.name]
          }
        })
      }
    }
  },
  components: { dialogItem },
  created() {
    this.$eventBus.$on('radioChecked', (data) => {
      this.selectedVal = data
    })
    this.$eventBus.$on('checkoutbox', (data) => {
      console.log(data)
      this.checkboxVal = data
    })
    this.$eventBus.$on(
      'searchDialogShow',
      (type, orderUser, value, checkedValues, formData) => {
        this.type = type
        this.orderUser = orderUser
        this.centerDialogVisible = true
        this.initCheckboxVal = checkedValues || []
        this.formData = formData
      }
    )

    this.$eventBus.$on(
      'searchDialogHide',
      function() {
        this.centerDialogVisible = false
      }.bind(this)
    )
  },
  computed: {
    padding() {
      return document.body.clientHeight
    }
  },
  methods: {
    sure() {
      if (this.initCheckboxVal.length > 0) {
        const returnValue = this.meta.returnValue || 'value';
        const returnDisplay = this.meta.returnDisplay || 'key';
        this.initCheckboxVal.forEach(item => {
          const obj = {};
          obj[returnValue] = item[0]
          obj[returnDisplay] = item[1]
          this.checkboxVal.push(obj)
        })
        // this.checkboxVal.concat(data)
      }

      if (this.checkboxVal.length !== 0) {
        var throwCheckbox = [this.checkboxVal, this.meta]
        this.$eventBus.$emit(this.orderUser, throwCheckbox, 'checkbox')
        this.checkboxVal = []
      } else if (this.selectedVal) {
        var throwArr = [this.selectedVal, this.meta]
        this.$eventBus.$emit(this.orderUser, throwArr, 'radio')
        this.selectedVal = ''
      }
      this.centerDialogVisible = false
    }
  }
}
</script>
<style lang="scss">
.el-dialog__wrapper{
  overflow: hidden;
  .el-dialog--center {
    display: flex;
    flex-direction: column;
  }
  .dialog-report {
    .el-dialog__body {
      .dialog-report {
        height: 500px !important;
        .el-pagination {
          margin-top: 20px;
        }
      }
    }
    .el-dialog__footer {
      margin-top: 100px;
      text-align: right;
    }
  }
}

</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.dialogsearch /deep/ .el-dialog__body {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.dialogsearch /deep/ .dialog-report {
    flex: 1;
    display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/searchDialog/dialog.vue